<template>
  <v-container>
  <button class="d-none" v-shortkey="['enter']" @shortkey="enterClick()"></button>
    <!-- Create new application or continue to an application that already exist -->
    <template v-if="!currentStep || currentStep === 0">
      <ApplicationNewOrContinue @showApplication="showApplication" />
    </template>
    <template v-else>
      <!-- The stepper -->
      <v-stepper flat v-model="currentStep">
        <v-stepper-header>
          <template v-for="idx in numSteps">
            <v-stepper-step :key="idx" :complete="idx < currentStep" :step="idx"></v-stepper-step>
            <v-divider :key="'div-' + idx" v-if="idx < numSteps"></v-divider>
          </template>
        </v-stepper-header>

        <!-- The steps -->
        <v-stepper-items>
          <v-stepper-content step="1">
            <ApplicationWelcome :step="1" @goToStep="goToStep" v-if="currentStep === 1" />
          </v-stepper-content>
          <v-stepper-content step="2">
            <ApplicationPersonalNumber :step="2" @goToStep="goToStep" v-if="currentStep === 2" />
          </v-stepper-content>
          <v-stepper-content step="3">
            <ApplicationPhone :step="3" @goToStep="goToStep" v-if="currentStep === 3" />
          </v-stepper-content>
          <v-stepper-content step="4">
            <ApplicationEmail :step="4" @goToStep="goToStep" v-if="currentStep === 4" />
          </v-stepper-content>
          <v-stepper-content step="5">
            <ApplicationProfession :step="5" @goToStep="goToStep"  v-if="currentStep === 5" />
          </v-stepper-content>
          <v-stepper-content step="6">
            <ApplicationProfessionOrientation :step="6" @goToStep="goToStep" v-if="currentStep === 6" />
          </v-stepper-content>
          <v-stepper-content step="7">
            <ApplicationWorkplace :step="7" @goToStep="goToStep"  v-if="currentStep === 7" />
          </v-stepper-content>
          <v-stepper-content step="8">
            <ApplicationDepartments :step="8" @goToStep="goToStep"  v-if="currentStep === 8"></ApplicationDepartments>
          </v-stepper-content>
          <v-stepper-content step="9">
            <ApplicationInstructor :step="9" @goToStep="goToStep"  v-if="currentStep === 9" />
          </v-stepper-content>
          <v-stepper-content step="10">
            <ApplicationDate :step="10" @goToStep="goToStep"  v-if="currentStep === 10" />
          </v-stepper-content>
          <v-stepper-content step="11">
            <ApplicationMessage :step="11" @goToStep="goToStep" v-if="currentStep === 11" />
          </v-stepper-content>
          <v-stepper-content step="12">
            <ApplicationReview :step="12" @goToStep="goToStep" v-if="currentStep === 12" />
          </v-stepper-content>
          <v-stepper-content step="13">
            <ApplicationThanks :step="13" @goToStep="goToStep" v-if="currentStep === 13" />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </template>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import API from '@/services/api.js'
// new steps
import ApplicationNewOrContinue from '@/components/Application/ApplicationNewOrContinue'
import ApplicationWelcome from '@/components/Application/Instructor/ApplicationWelcome'
import ApplicationPersonalNumber from '@/components/Application/Instructor/ApplicationPersonalNumber'
import ApplicationPhone from '@/components/Application/Instructor/ApplicationPhone'
import ApplicationEmail from '@/components/Application/Instructor/ApplicationEmail'
import ApplicationProfession from '@/components/Application/Apprentice/ApplicationProfession'
import ApplicationProfessionOrientation from '@/components/Application/Apprentice/ApplicationProfessionOrientation'
import ApplicationInstructor from '@/components/Application/Instructor/ApplicationInstructor'
import ApplicationWorkplace from '@/components/Application/Instructor/ApplicationWorkplace'
import ApplicationDate from '@/components/Application/Instructor/ApplicationDate'
import ApplicationDepartments from '@/components/Application/Apprentice/ApplicationDepartments'
import ApplicationReview from '@/components/Application/Instructor/ApplicationReview'
import ApplicationThanks from '@/components/Application/Instructor/ApplicationThanks'
import ApplicationMessage from '../../components/Application/Apprentice/ApplicationMessage.vue'
// @group Application
// Main component for company application
export default {
  name: 'CreateApplication',

  props: {
    // The step number if there is any from draft applications
    setStep: Number
  },

  components: {
    ApplicationNewOrContinue,
    ApplicationWelcome,
    ApplicationPersonalNumber,
    ApplicationPhone,
    ApplicationEmail,
    ApplicationProfession,
    ApplicationProfessionOrientation,
    ApplicationInstructor,
    ApplicationWorkplace,
    ApplicationDepartments,
    ApplicationDate,
    ApplicationReview,
    ApplicationThanks,
    ApplicationMessage
  },

  data: () => ({
    numSteps: 13
  }),

  created() {
    if (!this.selectedApplication || +this.$route.params.appid !== this.selectedApplication.id) {
      this.initApplication()
    }
    if (typeof this.setStep !== 'undefined') {
      this.setCurrentStep(this.setStep)
    }
  },

  watch: {
    /**
     * @vuese
     * Used to store the current step to store when step is changed
     * @arg The argument is an integer value representing the current step number
     */
    setStep(step) {
      this.setCurrentStep(step)
    },
    '$route.query.step': {
      handler: function (step) {
        this.goToStep(step)
      },
      deep: true,
      immediate: true
    },
    currentStep(newVal) {
      if (this.currentStep && this.selectedApplication.id) {
        const appId = this.selectedApplication.id
        const companyId = this.$route.params.id
        this.$router.push({path: `/company/${companyId}/create-applications/${appId}`, query: {step: this.currentStep}})
      }
    },
    $route(to, from) {
      this.setSelectedApplication(null)
      this.initApplication()
    }
  },

  computed: {
    ...mapGetters('application', ['selectedApplication', 'currentStep']),
    ...mapGetters('currentuser', ['currentUser', 'isLoggedIn', 'isApprentice', 'isInstructor', 'isCompanyUser'])
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.preventNav)
  },
  methods: {
    ...mapActions('application', ['setSelectedApplication', 'setCurrentStep']),
    preventNav(event) {
      if (!this.isEditing) return
      event.preventDefault()
      setTimeout(function () {
        window.location = '/'
      }, 0)
      window.onbeforeunload = null
      return ''
    },
    enterClick(){
      return
    },
    nextStep(){
      console.log("jeststep")
    },
    /**
     * @vuese
     * Used to  move from step to step based on current step
     * @arg The argument is an integer value representing the current step number
     */
    goToStep(step) {
      switch (step) {
        case '+1':
          this.setCurrentStep(this.currentStep + 1)
          break
        case '+2':
          this.setCurrentStep(this.currentStep + 2)
          break
        case '-1':
          this.setCurrentStep(this.currentStep - 1)
          break
        case '-2':
          this.setCurrentStep(this.currentStep - 2)
          break
        case 'last':
          this.setCurrentStep(this.numSteps)
          break
        default:
          this.setCurrentStep(Number(step))
      }

      //- Scroll to top on page
      this.$nextTick(this.$scrollToTop)
    },

    /**
     * @vuese
     * Used to fetch an application if there is any / or create a new one
     * @arg The argument is an integer value representing the application id if it exist
     */
    initApplication() {
      const id = +this.$route.params.appid
      const companyId = this.$route.params.id
      if (Number.isNaN(id) && this.$route && this.$route.name!="CreateCompanyApplications") {
        this.$router.push({path: `/company/${companyId}/create-applications`})
        return
      }
      if (id > 0) {
        //- Old application
        API.getApplication(id)
          .then(response => {
            this.setSelectedApplication(response.data)
            //- Calculate what's done
            if (this.selectedApplication.step && this.selectedApplication.step < this.numSteps) {
              this.setCurrentStep(this.selectedApplication.step)
            } else {
              this.setCurrentStep(1)
            }
          })
          .catch(error => {
            console.log('There was an error:', error)
            this.$router.push({path: `/company/${companyId}/create-applications`})
          })
      } else if (id === -1) {
        this.setSelectedApplication({})
        //- New application start from step 1
        this.setCurrentStep(1)
      }
    },

    showApplication(obj) {
      if(obj.isCompany) {
        const companyId = this.$route.params.id
        this.$router.push({path: `/company/${companyId}/create-applications/${obj.id}`, query: {step: 1}})
      }
      else {
        this.$router.push({path: `/application/${obj.id}`})
      }
    }
  }
}
</script>
<style >
</style>
